import { render } from "./LineItemsTable.vue?vue&type=template&id=6b6b08dd&scoped=true"
import script from "./LineItemsTable.vue?vue&type=script&lang=js"
export * from "./LineItemsTable.vue?vue&type=script&lang=js"

import "./LineItemsTable.vue?vue&type=style&index=0&id=6b6b08dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6b08dd"]])

export default __exports__